export default __webpack_public_path__ + "static/media/jacobLaframboise.72bda914.jpg";